import classNames from 'classnames'
import { ReactNode } from 'react'
import styles from './index.module.css'

export type ToggleButtonGroupSize = 'sm' | 'lg'

export type ToggleButtonGroupProps<V extends string> = {
  options: ReadonlyArray<{ value: V; label: ReactNode }>
  value: V
  onChange: (value: V) => void
  'aria-label': string
  // lg is 40px high, sm 32px. The group fills its container; give the container a width to fix it.
  size?: ToggleButtonGroupSize
  className?: string
}

export const ToggleButtonGroup = <V extends string>({
  options,
  value,
  onChange,
  size = 'lg',
  className,
  'aria-label': ariaLabel
}: ToggleButtonGroupProps<V>) => (
  <div
    role="group"
    aria-label={ariaLabel}
    className={classNames(styles.group, className)}
    // Equal columns, but never narrower than a label: a label that does not fit widens the group
    // rather than running into the button's padding.
    style={{ gridTemplateColumns: `repeat(${options.length}, minmax(max-content, 1fr))` }}
  >
    {options.map((option) => (
      <button
        key={option.value}
        type="button"
        aria-pressed={option.value === value}
        onClick={() => onChange(option.value)}
        className={classNames(styles.button, styles[size])}
      >
        {option.label}
      </button>
    ))}
  </div>
)
